/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Senddrafts_Autosave_Saving3Inputs */

const en_coinvestments_senddrafts_autosave_saving3 = /** @type {(inputs: Coinvestments_Senddrafts_Autosave_Saving3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving…`)
};

/**
* | output |
* | --- |
* | "Saving…" |
*
* @param {Coinvestments_Senddrafts_Autosave_Saving3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_autosave_saving3 = /** @type {((inputs?: Coinvestments_Senddrafts_Autosave_Saving3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Autosave_Saving3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_autosave_saving3(inputs)
});
export { coinvestments_senddrafts_autosave_saving3 as "coInvestments_sendDrafts_autoSave_saving" }